import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    NREData,
    santerPRSCregistraPrescrizioneOnExaminationRequest,
    santerPRSCregistraPrescrizioneOnPatientRequest,
    santerPRSCregistraPrescrizioneResponse
} from '../models/vnext.models';
import { TranslateService } from '@ngx-translate/core';
import { ModalDialogNotificationService, NotificationType, NotificationService, ServerRootService } from '@se/se.ui.html5';



@Injectable({
    providedIn: 'root',
})
export class NreService extends ServerRootService {

    // constructor

    constructor(private httpClient: HttpClient,
        private translate: TranslateService,
        private modalDialogNotificationService: ModalDialogNotificationService,
        private notificationService: NotificationService) {
        super();
    }

    getSanterPRSCregistraPrescrizioneOnPatient(patientRequest: santerPRSCregistraPrescrizioneOnPatientRequest) {
        return this.httpClient.post<santerPRSCregistraPrescrizioneResponse>(
            this.getServerRoot() + '/NRE/GetSanterPRSCregistraPrescrizioneOnPatient',
            patientRequest,
            this.buildOptions()
        );
    }

    getSanterPRSCregistraPrescrizioneOnExaminations(examinationRequest: santerPRSCregistraPrescrizioneOnExaminationRequest) {
        return this.httpClient.post<santerPRSCregistraPrescrizioneResponse>(
            this.getServerRoot() + '/NRE/GetSanterPRSCregistraPrescrizioneOnExaminations',
            examinationRequest,
            this.buildOptions()
        );
    }

     updateNRE(nreData:NREData[]){
         return this.httpClient.post(
             this.getServerRoot() + '/RadiologyCommon/UpdateNRE',
             nreData,
             this.buildOptions()
         );
    }

    public notifyMedicalPrescriptionError(e: any) {
        // Si è verificato un problema durante l'esecuzione delle operazioni richieste.
        // Premere il pulsante dei messaggi di errore in alto a destra per avere maggiori informazioni.
        let message = this.translate.instant('GenericExecutionFailure');
        let faultType = e?.error?.estensaFaultDetails?.typeName;
        let patient = "";
        if (faultType) {
            switch (faultType) {
                case 'SanterFault':
                    message = this.translate.instant(e?.error?.estensaFaultDetails?.estensaFault?.message);
                    break;
                case 'SanterASLCodeFault':
                    patient = e?.error?.estensaFaultDetails?.estensaFault?.patient;
                    if (!patient)
                        patient = 'patient unknown';
                    message = this.translate.instant('Exception_SanterASLCodeFault', { p0: patient });
                    break;

                case 'SanterTaxCodeFault':
                    patient = e?.error?.estensaFaultDetails?.estensaFault?.patient;
                    if (!patient)
                        patient = 'patient unknown';
                    message = this.translate.instant('Exception_SanterTaxCodeFault', { p0: patient });
                    break;
                default:
                    message = this.translate.instant('GenericExecutionFailure');
            }
        }
        else if (e.statusText) {
            message = e.statusText;
        }

        this.modalDialogNotificationService.notify({
            buttonYes: false,
            buttonNo: false,
            buttonCancel: false,
            buttonOk: true,
            title: this.translate.instant('Error'),
            message: message,
            type: NotificationType.warning,
        });

        this.notificationService.error(message, this.translate.instant('CreateMedicalPrescription') +
            ' - ' + this.translate.instant('Error'));
    }




}
